import React from 'react'
import PropTypes from 'prop-types'

import Checkbox from 'material-ui/Checkbox'
import ReminderIcon from 'resources/reminder_icon.svg'

import Assignees from '../common/Assignees'
import TaskEditItem from './TaskEditItem'

export default class TaskItem extends React.Component {

  static propTypes = {
    task: PropTypes.shape().isRequired,
    dbPath: PropTypes.string,
    workers: PropTypes.any,
    enableReminders: PropTypes.bool,
    onCheck: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      task: props.task,
      mode: 'view'
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ task: nextProps.task })
  }

  handleToggleTask = event => {
    event.preventDefault()
    this.props.onCheck(this.state.task)
  }

  handleCancel = () => {
    this.setState({ mode: 'view' })
  }

  handleTaskTouchTap = event => {
    event.preventDefault()
    this.setState({ mode: 'edit' })
  }

  handleSave = ({ text, showReminder }) => {
    this.setState({ mode: 'view' })
    this.props.onSave(this.state.task, { text, showReminder })
  }

  render() {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'row' }}>
        <Checkbox
          style={{ width: 'auto' }}
          inputStyle={{}}
          iconStyle={{ fill: '#8c8c8c' }}
          checked={this.state.task.done}
          onCheck={this.handleToggleTask} />

        { this.state.mode === 'view'
          ?
          (
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <div
                style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: 14 }}
                onTouchTap={this.handleTaskTouchTap}>
                <div style={{cursor: 'pointer', color: '#757575'}}>{this.state.task.text}</div>
              </div>
              <Assignees
                dbPath={this.props.dbPath}
                assignees={this.state.task.assignees}
                workers={this.props.workers}/>

              {
                this.state.task.reminderId
                &&
                <img
                  style={{ marginLeft: 8, marginRight: 8 }}
                  src={ReminderIcon}
                  width={24}
                  height={24}/>
              }
            </div>
          )
          : <TaskEditItem
            text={this.state.task.text}
            showReminder={this.state.task.reminderId !== undefined}
            enableReminders={this.props.enableReminders}
            mode='edit'
            onCancel={this.handleCancel}
            onDelete={() => this.props.onDelete(this.state.task)}
            onSave={this.handleSave} />
        }

      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/tasks/TaskItem.js